export default {
  // new Intl.NumberFormat('en-US',{ style: 'currency', currency: 'USD' }).format(money); // '$100.00'
  // currentMonthTotal: state => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(Math.round(state.currentMonthTotal)),
  downloading: state => state.downloading,
  byteDownloaded: state => state.byteDownloaded,
  totalByte: state => state.totalByte,
}
